export default "__VITE_ASSET__CUb2Z4yC__"